export const CMS_PAGE       = Symbol('CMS_PAGE');
export const PROCESS_PAGE   = Symbol('PROCESS_PAGE');